// set the code for product review //
jQuery(document).ready(function(){
//$(function(){
  
  if(jQuery('#shopify-product-reviews').length > 0 ){
    
    	//$('#shopify-product-reviews .spr-review').append('<div class="loader"></div>');
    	jQuery('#shopify-product-reviews').append('<div class="filter-loader"><div class="loader-img-new"></div></div>');
    	jQuery('.filter-loader').show();     	
    
  }
  
  function SetReviewData() {
    
    	//alert('Called');	
    
        if ($("#shopify-product-reviews .spr-review").length <= 0){
            setTimeout(SetReviewData,500);
            console.log('time out called');
          	return;
        }
    
      	$(".spr-reviews .spr-pagination").insertAfter(".spr-content .spr-reviews");
		$("#shopify-product-reviews .spr-review").each(function(){
          	
          	$(this).find(".spr-review-header").prepend('<div class="authfull-info"></div>');
         
			$(this).find(".spr-review-header .auth-name").insertBefore($(this).find(".authfull-info"));
            $(this).find(".spr-review-header .spr-review-header-byline").appendTo($(this).find(".authfull-info"));
            $(this).find(".spr-review-header .spr-starratings").insertBefore($(this).find(".reviewdate"));
            $(this).find(".spr-review-header .spr-review-header-title").appendTo($(this).find(".authfull-info")); 
          	$('#shopify-product-reviews .spr-container').css({"opacity": "1"}); 
          	
     		jQuery('.filter-loader').hide(); 
		});
	}
  
  setTimeout(SetReviewData,500);
  
	$(document).on("click",".spr-pagination a",function(){
		setTimeout(function(){
          $(".spr-content > .spr-pagination").remove();
          $(".spr-reviews .spr-pagination").insertAfter(".spr-content .spr-reviews");
          $("#shopify-product-reviews .spr-review").each(function(){
              $(this).find(".spr-review-header").prepend('<div class="authfull-info"></div>');
              $(this).find(".spr-review-header .auth-name").insertBefore($(this).find(".authfull-info"));
              $(this).find(".spr-review-header .spr-review-header-byline").appendTo($(this).find(".authfull-info"));
              $(this).find(".spr-review-header .spr-starratings").insertBefore($(this).find(".reviewdate"));
              $(this).find(".spr-review-header .spr-review-header-title").appendTo($(this).find(".authfull-info"));
          });
		},1500);
	});
  
  
//});
});

$.fn.equalHeights = function(){
	var max_height = 0;
	$(this).each(function(){
		max_height = Math.max($(this).height(), max_height);
	});
	$(this).each(function(){
		$(this).height(max_height);
	});
};

$(document).ready(function(){
    $('.Product-title h3,.card__heading.h5,.card__information p').equalHeights();
});

// Product Details page Review text change

function showHide(element) {
  // Hide all hidden content elements
  var allHiddenContent = document.querySelectorAll('.tooltip_color');
  allHiddenContent.forEach(function(content) {
    content.style.display = 'none';
  });

  // Display the corresponding hidden content
  var nextElement = element.nextElementSibling;
  if (nextElement && nextElement.classList.contains('tooltip_color')) {
    nextElement.style.display = 'block';
  }
}